<pdq-card variant="flat" color="white">
  <pdq-expandable-section [id]="sectionId" [cacheState]="true" [initialCollapsed]="false">
    <div sectionHeader class="section-heading">
      <pdq-heading element="h6">{{ title }}</pdq-heading>
      @if (subtitle) {
        <p class="body-12-regular section-heading__subtitle">{{ subtitle }}</p>
      }
    </div>

    <div class="banner-fields">
      <div class="banner-field">
        <p class="body-14-medium">Banner text</p>
        <rich-textarea
          [initialContent]="formGroup.controls.text.value"
          (contentChange)="onBannerTextChange($event)"
          [placeholder]="placeholder ?? ''"
          [disabledFormats]="['align', 'header']"
          [invalid]="formGroup.controls.text.dirty && formGroup.controls.text.invalid"
          errorMsg="Banner text is required"></rich-textarea>
      </div>
      <pdq-dropdown
        title="Style"
        [options]="styleOptions"
        [defaultOption]="selectedStyleOption()"
        [useOverlay]="true"
        (onChange)="onStyleChange($event)"></pdq-dropdown>
    </div>
  </pdq-expandable-section>
</pdq-card>
